import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import orderBy from 'lodash/orderBy';
import { view } from 'react-easy-state';

import { getNodes } from '../../utils';

import Grid from '../grid/grid';
import Album from './album';
import {
  SmallTitle,
  SubTitle,
  Title,
} from '../elements';
import { settingsAlbums } from '../grid/constants';

export default () => (
  <StaticQuery
    query={graphql`
      query AlbumsQuery {
        albums: allWordpressWpAlbums {
          edges {
            node {
              id
              title
              menu_order
              featured_media {
                source_url
                localFile {
                  childImageSharp {
                    fluid(
                      maxWidth: 700
                      traceSVG: {
                        color: "#FFE1E2"
                      }
                    ) {
                      ...GatsbyImageSharpFluid_tracedSVG
                    }
                  }
                }
              }
              acf {
                artist
                year
                itunes
                spotify
                youtube
              }
            }
          }
        }
      }
    `}
    render={data => <Albums data={data} />}
  />
);

const Albums = view(({ data }) => {
  const albums = orderBy(getNodes(data.albums), 'menu_order');

  return (
    <div className="site-section" id="albums" css={{ padding: '6rem 0' }}>
      <section className="section">
        <div className="container">
          <div css={{ maxWidth: '50rem' }}>
            <SmallTitle>
              Albums
            </SmallTitle>

            <Title>
              What makes a good song?<br />
              The music or melody?
            </Title>
            <SubTitle>
              It&rsquo;s neither nor. It&rsquo;s what you want to say.<br />
              It&rsquo;s always the message!
            </SubTitle>
          </div>
        </div>
      </section>

      {albums && (
        <Grid
          data={albums}
          style={{ overflowX: 'scroll', paddingBottom: '0.5rem' }}
          slickSettings={settingsAlbums}
          render={({ item, ...props }) => (
            <Album
              album={item}
              {...props}
            />
          )}
        />
      )}
    </div>
  );
});
